"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCyclePeriodDate = void 0;
/**
 * Verifica se a data atual está dentro do intervalo de datas especificado.
 * formato "ISO 8601".
 * @param {string} startDateStr
 * @param {string} endDateStr
 * @returns {boolean} - Retorna true se a data atual estiver dentro do intervalo e não for a data de término, caso contrário, false.
 */
const getCyclePeriodDate = (startDateStr, endDateStr) => {
    const startDate = new Date(startDateStr).getTime();
    const endDate = new Date(endDateStr).getTime();
    const currentDate = Date.now();
    return currentDate >= startDate && currentDate < endDate;
};
exports.getCyclePeriodDate = getCyclePeriodDate;
